<template>
    <svg class="pin icon" width="24" height="24" viewBox="0 0 115 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M57.1818 179.714C25.6501 179.714 0 154.064 0 122.532V36.7597C0 16.501 16.501 0 36.7597 0C57.0184 0 73.5195 16.501 73.5195 36.7597V118.448C73.5195 125.212 68.03 130.701 61.2662 130.701C54.5024 130.701 49.013 125.212 49.013 118.448V36.7597C49.013 30.0123 43.5072 24.5065 36.7597 24.5065C30.0123 24.5065 24.5065 30.0123 24.5065 36.7597V122.532C24.5065 140.553 39.1614 155.208 57.1818 155.208C75.2023 155.208 89.8572 140.553 89.8572 122.532V12.2532C89.8572 5.48945 95.3466 0 102.11 0C108.874 0 114.364 5.48945 114.364 12.2532V122.532C114.364 154.064 88.7135 179.714 57.1818 179.714Z" />
    </svg>
</template>

<script>
export default {}
</script>